// Дополняет число до двух цифр
export const pad = (n: number) => `${Math.floor(Math.abs(n))}`.padStart(2, '0');
